// REMIX HMR BEGIN
if (!window.$RefreshReg$ || !window.$RefreshSig$ || !window.$RefreshRuntime$) {
  console.warn('remix:hmr: React Fast Refresh only works when the Remix compiler is running in development mode.');
} else {
  var prevRefreshReg = window.$RefreshReg$;
  var prevRefreshSig = window.$RefreshSig$;
  window.$RefreshReg$ = (type, id) => {
    window.$RefreshRuntime$.register(type, "\"app\\\\routes\\\\_index - Copy.tsx\"" + id);
  }
  window.$RefreshSig$ = window.$RefreshRuntime$.createSignatureFunctionForTransform;
}
import * as __hmr__ from "remix:hmr";
if (import.meta) {
  import.meta.hot = __hmr__.createHotContext(
  //@ts-expect-error
  "app\\routes\\_index - Copy.tsx");
  import.meta.hot.lastModified = "1759761980446.823";
}
// REMIX HMR END

import { WelcomeSection } from "~/components/pages/home/WelcomeSection/WelcomeSection";
import { StudioTypesSection } from "~/components/pages/home/StudioTypesSection/StudioTypesSection";
import { LocationsSection } from "~/components/pages/home/LocationsSection/LocationsSection";
import { PeopleSection } from "~/components/shared/PeopleSection";
import { EquipmentSection } from "~/components/pages/home/EquipmentSection";
import { EventsSection } from "~/components/pages/home/EventsSection";
import { SupportSection } from "~/components/pages/home/SupportSection";
import { MembershipSection } from "~/components/shared/MembershipSection";
import { PublicRoute } from "~/components/RouteProtection";
export const meta = () => {
  return [{
    title: "Nomadics Studios - Your Creative Space Awaits"
  }, {
    name: "description",
    content: "Connect creators with premium studio spaces, professional equipment, and a thriving creative community."
  }];
};
export default function Index() {
  return <PublicRoute>
      <div className="relative">
        <WelcomeSection />
        <StudioTypesSection />
        <LocationsSection />
        <PeopleSection title="THE PEOPLE TO HELP YOU CREATE" buttonText="FIND YOUR CREATIVE SUPPORT" eyebrow="OUR TEAM" />
        <EquipmentSection />
        <EventsSection />
        <SupportSection />
        <MembershipSection />
      </div>
    </PublicRoute>;
}
_c = Index;
var _c;
$RefreshReg$(_c, "Index");

window.$RefreshReg$ = prevRefreshReg;
window.$RefreshSig$ = prevRefreshSig;